// extracted by mini-css-extract-plugin
export default {"label":"label__xm8Vz"};